// Libraries
import React from 'react';

// Supermove
import {Space, Styled} from '@supermove/components';
import {gql} from '@supermove/graphql';
import {ProjectTypeModel} from '@supermove/models';

// Shared
import Text from '@shared/design/components/Text';
import TextTooltip from '@shared/design/components/TextTooltip';

const Container = Styled.View`
  flex-direction: row;
  align-items: center;
`;

const ProjectTypeDot = Styled.View<{color: string}>`
  height: 8px;
  width: 8px;
  border-radius: 4px;
  background-color: ${({color}) => color};
`;

const TooltipContainer = Styled.View`
`;

const ProjectDot = ({color, tooltip}: {color: string; tooltip?: string}) => {
  if (tooltip) {
    return (
      <TextTooltip text={tooltip} placement={'top'}>
        <TooltipContainer>
          <ProjectTypeDot color={color} />
        </TooltipContainer>
      </TextTooltip>
    );
  }

  return <ProjectTypeDot color={color} />;
};

const ProjectTypeLabel = ({
  projectType,
  style,
  tooltip,
}: {
  projectType: ProjectTypeModel;
  style?: React.CSSProperties;
  tooltip?: string;
}) => {
  return (
    <Container style={{...style}}>
      <ProjectDot color={projectType.color} tooltip={tooltip} />
      <Space width={8} />
      <Text.Micro>{projectType.name}</Text.Micro>
    </Container>
  );
};

// --------------------------------------------------
// Data
// --------------------------------------------------

ProjectTypeLabel.fragment = gql`
  fragment ProjectTypeLabel on Project {
    id
    projectType {
      id
      name
      color
    }
  }
`;

ProjectTypeLabel.Dot = ProjectDot;

export default ProjectTypeLabel;
